import { useEffect, useState } from "react";
import { BarChart3 } from "lucide-react";
import { api } from "@/lib/api";

const COLS = [["jobs", "Jobs"], ["live_jobs", "Live"], ["applicants", "Applicants"], ["shortlisted", "Shortlisted"], ["hired", "Hired"], ["hire_rate", "Hire rate"]];
const cell = (r, k) => (k === "hire_rate" ? `${r[k]}%` : r[k]);

export function HiringStats() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/hiring-stats").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d || !d.employers.length) return null;
  return (
    <div data-testid="hiring-stats" className="overflow-x-auto rounded-2xl border border-line bg-surface">
      <p className="flex items-center gap-2 border-b border-line px-5 py-3 font-semibold text-ink"><BarChart3 className="h-4 w-4 text-aqua" />Hiring stats by employer</p>
      <table className="w-full min-w-[640px] text-sm">
        <thead><tr className="text-left text-xs uppercase tracking-wide text-ink-3">
          <th className="px-5 py-2 font-medium">Employer</th>{COLS.map(([k, l]) => <th key={k} className="px-3 py-2 text-right font-medium">{l}</th>)}
        </tr></thead>
        <tbody>
          {d.employers.map((r) => (
            <tr key={r.employer_id} data-testid={`hiring-row-${r.employer_id}`} className="border-t border-line">
              <td className="px-5 py-2.5 font-medium text-ink">{r.company}<span className="ml-2 text-xs font-normal capitalize text-ink-3">{r.employer_status}</span></td>
              {COLS.map(([k]) => <td key={k} className={`px-3 py-2.5 text-right tabular-nums ${k === "hired" && r[k] ? "font-semibold text-emerald-700" : "text-ink-2"}`}>{cell(r, k)}</td>)}
            </tr>
          ))}
          <tr data-testid="hiring-totals" className="border-t-2 border-line bg-canvas-2 font-semibold text-ink">
            <td className="px-5 py-2.5">All employers</td>{COLS.map(([k]) => <td key={k} className="px-3 py-2.5 text-right tabular-nums">{cell(d.totals, k)}</td>)}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
